import { Injectable } from '@angular/core';

import { Player } from '../model/player';
import { LesionModel } from '../model/player-health-problems';

// Import mock data
import players from './mock_data.json';
import lesiones from './mock-lesiones.json';

@Injectable({
  providedIn: 'root'
})
export class PlayerService {

  constructor() {
  }

  getPlayers(): Player[] {
    return players;
  }

  getPlayerHealthProblems(id:string): LesionModel[] {
    const l = lesiones.find(l => l.id === id);
    if (!l) {
      return [];
    }
    return l.lesiones.map(({dateFrom,dateTo,desc}) => ({
      dateFrom: new Date(dateFrom),
      dateTo: new Date(dateTo),
      desc
    }));
  }

}
